module.exports = __webpack_public_path__ + "static/media/flying-robot.82b4f76b.png";